import { render, staticRenderFns } from "./LocationMovement.vue?vue&type=template&id=5308e257"
import script from "./LocationMovement.vue?vue&type=script&lang=js"
export * from "./LocationMovement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports